class LookBookModal extends HTMLElement {
  connectedCallback() {
    this.closeButton = this.querySelector('.close-modal');
    this.header = document.getElementById('shopify-section-header');
    this.announcementBar = document.getElementById('announcement-bar-wrapper');
    this.announcementBarCloseButton = document.getElementById('hideAnnouncement');
    this.swiperContainer = document.querySelector('.swiper-container');
    this.swiperWrapper = document.querySelector('.swiper-wrapper');

    document.addEventListener("DOMContentLoaded", () => {
      this.lookbookLooks = document.querySelector(".lookbook-looks");
      this.lookbookText = document.querySelector('.lookbook-text');
      this.footer = document.querySelector('#shopify-section-footer');
    });

    // this.updateModalHeight();
    this.updateSwiperHeight();

    window.addEventListener('resize', debounce(() => {
      // this.updateModalHeight();
      this.updateSwiperHeight();
    }, 200));

    let swiper = null;
    this.swiperInitialised = false;

    const initSwiper = (startIndex) => {
      swiper = new Swiper(".section-lookbook .swiper-lookbook", {
        autoHeight: true,
        observer: true,
        observeParents: true,
        initialSlide: startIndex,
        slidesPerView: 1,
        centeredSlides: true,
        speed: 800,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
        breakpoints: {
          768: {
            autoHeight: false,
            observer: false,
            observeParents: false,
            slidesPerView: 1,
            speed: 800,
            touchStartForcePreventDefault: true,
            allowTouchMove: false,
            preventClicks: true,
          },
        },
        on: {
          resize: function () {
              const swiperWrapper = this.el.querySelector('.swiper-wrapper');
              if (window.matchMedia('(min-width: 768px)').matches) {
                 // swiperWrapper.style.height = 'auto';
              }
          }
        },
        loop: true,
        on: {
            slideChangeTransitionStart: syncSlides // Sync at the start of the transition
        }
      });


      // Function to sync slides
      function syncSlides() {
        setTimeout(() => {
          const activeIndex = swiper.realIndex; // This gets the logical index of the active slide
          const activeLookSlide = document.querySelector(`[lookbook-look-slide="${activeIndex}"]`);
      
          if (activeLookSlide) {
              const productSlides = document.querySelectorAll('[lookbook-product-slide]');
              productSlides.forEach(slide => {
                  if (slide.getAttribute('lookbook-product-slide') === String(activeIndex)) {
                      slide.classList.add('active');
                      setTimeout(() => {
                        slide.classList.add('fade-in');
                      }, 50); // Adjust the delay (in milliseconds) as needed
                  } else {
                      slide.classList.remove('active');
                      slide.classList.remove('fade-in');
                  }
              });
          }
      }, 50); // Adjust the delay (in milliseconds) as needed
      }

      // Initial sync
      syncSlides();
    };


    const images = document.querySelectorAll(".lookbook-main-image");
    images.forEach((image, index) => {
      image.addEventListener("click", (event) => {
        const modal = document.querySelector('lookbook-modal');
        modal.dispatchEvent(new CustomEvent('open-carousel', {
          detail: { startIndex: index }
        }));
      });
    });


    this.addEventListener('open-carousel', (event) => {
      const startIndex = event.detail.startIndex || 0;
      this.style.display = 'flex';
      this.updateSwiperHeight();

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.lookbookText.setAttribute('style', 'display:none !important');
      }

      if (!this.swiperInitialized) {
        initSwiper(startIndex);
      } else {
        this.swiper.slideTo(startIndex, 0);
      }
      this.updateSwipeImageHeight();
      this.lookbookLooks.setAttribute('style', 'display:none !important');
      this.lookbookText.setAttribute('style', 'display:none !important'); 
      this.footer.setAttribute('style', 'display:none !important'); 
    });
  
    this.closeButton.addEventListener("click", () => {
      this.swiperContainer.style.display = "none";
      swiper.destroy(true, true);
      this.lookbookLooks.style.display = "block";
      this.lookbookText.style.display = "block";
      this.footer.style.display = "block";

      if (window.matchMedia('(min-width: 768px)').matches) {
        document.body.style.overflow = "";
      }

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.lookbookText.setAttribute('style', 'display:block !important');
      }

      const productSlides = document.querySelectorAll('[lookbook-product-slide]');
      productSlides.forEach(slide => {
        slide.classList.remove('active');
        slide.classList.remove('fade-in');
      });

    });

    if (this.announcementBarCloseButton) {
      this.announcementBarCloseButton.addEventListener('click', () => {
        this.updateSwiperHeight();
      });
    }

  }

  updateSwipeImageHeight() {
    const image = document.querySelector('.swiper-slide-active .slide-image');
    if (image) {
        const imageHeight = image.offsetHeight;
        document.body.style.setProperty('--swipe-image-height', imageHeight + 'px');
    }
  };

  updateSwiperHeight() {
    let totalHeight = 0;

    if (this.header) {
      const headerRect = this.header.getBoundingClientRect();
      if (headerRect.top >= 0 && headerRect.bottom <= window.innerHeight) {
        totalHeight += this.header.offsetHeight;
      }
    }

    if (this.announcementBar) {
      const announcementBarRect = this.announcementBar.getBoundingClientRect();
      if (
        announcementBarRect.top >= 0 &&
        announcementBarRect.bottom <= window.innerHeight
      ) {
        totalHeight += this.announcementBar.offsetHeight;
      }
    }

    if (window.matchMedia('(min-width: 768px)').matches) {
      const swiperWrapper = document.querySelector('.swiper-lookbook');
      this.style.maxHeight = totalHeight > 0  ? `calc(100vh - ${totalHeight}px)` : '100vh';
      this.style.minHeight = totalHeight > 0  ? `calc(100vh - ${totalHeight}px)` : '100vh';
      swiperWrapper.style.maxHeight = totalHeight > 0  ? `calc(100vh - ${totalHeight}px)` : '100vh';
      swiperWrapper.style.minHeight = totalHeight > 0  ? `calc(100vh - ${totalHeight}px)` : '100vh';

      // width: calc(-107.25px + 75vh) !important;

    } else {
      const swiperWrapper = document.querySelector('.swiper-lookbook');
      this.style.maxHeight = '100%';
      swiperWrapper.style.maxHeight = '100%';
      this.style.minHeight = '100%';
      swiperWrapper.style.minHeight = '100%';
      document.body.style.overflow = "";
    }

    this.updateSwipeImageHeight();
    
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

}

customElements.define("lookbook-modal", LookBookModal);